import { useMutation, UseMutationOptions, useQuery } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "./apiService";

export const useGetRecipeIngredient = (tenantId: string) =>
  useQuery(
    ["getRecipeIngredients", tenantId],
    async () => {
      const response = await axiosApi.get(`/recipe-ingredients/${tenantId}`);
      return response?.data;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!tenantId
    }
  );

export const useCreateRecipeIngredient = (opt?: UseMutationOptions) =>
  useMutation<any, ApiServiceErr, any>(async data => {
    const response = await axiosApi.post(`/recipe-ingredients`, data);
    return response?.data;
  }, opt);
